export default "__VITE_ASSET__BUgknVau__"